<template>
    <div>
        <ais-instant-search :index-name="indexName" :search-client="searchClient">
            <ais-autocomplete>
                <div slot-scope="{ currentRefinement, indices, refine }">
                    <v-autocomplete
                            :loading="loading"
                            :items="indices[0].hits"
                            v-on:update:searchInput="updateSearch($event, refine)"
                            v-model="selectedUser"
                            class="mx-3 mb-4"
                            flat
                            hide-no-data
                            hide-details
                            return-object
                            no-filter
                            clearable
                            label="Find user..."
                            item-text="profile.email"
                            item-value="profile.email"
                    >
                        <template slot="item" slot-scope="data">
                            <v-list-tile-content>
                                <v-list-tile-title><ais-highlight attribute="profile.displayName" :hit="data.item" /></v-list-tile-title>
                                <v-list-tile-sub-title><ais-highlight attribute="profile.email" :hit="data.item" /></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </template>
                    </v-autocomplete>
                </div>
            </ais-autocomplete>
        </ais-instant-search>
        <template v-if="selectedUser">
            <v-list two-line subheader>
                <v-subheader style="height: 14px">Selected User:</v-subheader>
                <v-list-tile avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{selectedUser.profile.displayName}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{selectedUser.profile.email}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </template>
    </div>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'
  import {required} from 'vuelidate/lib/validators'
  import {AlgoliaSearchMixin} from '@/views/app/mixins'

  export default {
    name: 'TeamAddFields',
    mixins: [FieldsMixin, AlgoliaSearchMixin],
    props: {
      systemConfig: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      loading: false,
      selectedUser: null,
      search: null,
      items: [],
      // normal form data
      formData: {
        uid: null
      }
    }),
    validations: {
      formData: {
        uid: {
          required,
        }
      }
    },
    created () {
      this.setupSearchClient()
      // Set the initial formData, if it is specified. Important to note that we don't watch this value - any changes
      // should be done by the form itself, with the modified values pushed back up the chain via events.
      this.configureInitialValue()
    },
    computed: {
      indexName () {
        return `${this.indexPrefix}Users`
      }
    },
    methods: {
      updateSearch (eventData, refineFunc) {
        // TODO: handle undefined and clear the search index?
        // console.log(`Update event: ${eventData}`)
        if (eventData) {
          console.log('Updating algolia search')
          refineFunc(eventData)
        }
      }
    },
    watch: {
      selectedUser (newVal) {
        if (newVal) {
          this.formData.uid = newVal.objectID
        } else {
          this.formData.uid = null
        }
        this.$v.formData.uid.$touch()
      }
    }
  }
</script>

<style scoped>

</style>
